import { useState } from "react";
import { X } from "lucide-react";

export function Modal({ title, subtitle, onClose, children, wide = false, testId = "modal" }) {
  return (
    <div className="fixed inset-0 z-[70] bg-anthracite/70 flex items-start justify-center p-2 sm:p-4 overflow-y-auto" data-testid={testId}>
      <div className={`bg-ivory text-anthracite rounded-rama-lg w-full ${wide ? "max-w-5xl" : "max-w-2xl"} mt-2 sm:mt-6 mb-10 shadow-2xl`}>
        <div className="flex items-start justify-between p-4 sm:p-6 border-b border-black/10">
          <div>
            <div className="font-display text-2xl">{title}</div>
            {subtitle && <div className="text-sm text-ink-soft mt-1">{subtitle}</div>}
          </div>
          <button onClick={onClose} aria-label="Fermer" data-testid={`${testId}-close`} className="p-2 rounded hover:bg-black/5"><X size={18} /></button>
        </div>
        <div className="p-4 sm:p-6">{children}</div>
      </div>
    </div>
  );
}

export function Field({ label, children, hint }) {
  return (
    <label className="block">
      <span className="text-xs font-mono-caption text-ink-soft block mb-1.5">{label}</span>
      {children}
      {hint && <span className="text-xs text-ink-soft block mt-1">{hint}</span>}
    </label>
  );
}

export const inputCls = "w-full p-2.5 border border-black/15 rounded-rama-sm bg-white text-anthracite focus:border-bordeaux-700 outline-none text-sm";

export function useAsync() {
  const [busy, setBusy] = useState(false);
  const run = async (fn) => { setBusy(true); try { return await fn(); } finally { setBusy(false); } };
  return { busy, run };
}
